import React from "react";
import PropTypes from "prop-types";
import { Button, Stack } from "@mui/material";

const CookingControls = ({
  isReady,
  onCook,
  onCookLater,
  hasPrevious,
  onAddAnother,
  isSubmitting,
  mappedPositions,
  noIngredientsRequired,
}) => {
  let buttonText = "";
  if (isSubmitting) {
    buttonText = "Preparing...";
  } else if (isReady || noIngredientsRequired) {
    buttonText = "Start Cooking Now";
  } else {
    buttonText = "Check Ingredients";
  }
  console.log(">>>>>>>>>>>mappedPositions", mappedPositions);
  console.log(
    ">>>>>>>>>>>isReady, noIngredientsRequired",
    isReady,
    noIngredientsRequired
  );
  return (
    <Stack spacing={2} mt={4}>
      <Button
        variant="contained"
        size="large"
        fullWidth
        onClick={onCook}
        disabled={(!isReady && !noIngredientsRequired) || isSubmitting}
      >
        {buttonText}
      </Button>

      <Button
        variant="outlined"
        size="large"
        fullWidth
        onClick={onCookLater}
        disabled={(!isReady && !noIngredientsRequired) || isSubmitting}
      >
        Schedule Cooking
      </Button>

      {!hasPrevious && (
        <Button
          variant="text"
          size="large"
          fullWidth
          onClick={onAddAnother}
          disabled={(!isReady && !noIngredientsRequired) || isSubmitting}
        >
          + Add Another Recipe
        </Button>
      )}
    </Stack>
  );
};

CookingControls.propTypes = {
  isReady: PropTypes.bool.isRequired,
  onCook: PropTypes.func.isRequired,
  onCookLater: PropTypes.func.isRequired,
  hasPrevious: PropTypes.bool.isRequired,
  onAddAnother: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  noIngredientsRequired: PropTypes.bool,
};

export default CookingControls;
